import React from 'react';
import classNames from 'classnames';
import { IconType } from 'react-icons';
import Toggle from './Toggle';
import Icon from '../icons/Icon';

interface PreferencesToggleProps {
  style?: string;
  checked?: boolean;
  onPress: () => void;
  title: string;
  subTitle?: string;
  titleStyle?: string;
  disabled?: boolean;
  icon?: IconType;
}

export default function PreferencesToggle({
  style = '',
  onPress,
  checked,
  title,
  subTitle,
  titleStyle = '',
  disabled = false,
  icon,
}: PreferencesToggleProps): JSX.Element {
  return (
    <div
      className={classNames('flex cursor-pointer flex-row items-center gap-2 py-4', style, {
        'pointer-events-none opacity-50': disabled,
      })}
      onClick={onPress}>
      <div className="flex flex-1 flex-col gap-1">
        <div className="flex flex-row items-center gap-2">
          {icon && <Icon icon={icon} className="my-auto inline-block h-5 w-5" aria-hidden />}
          <span className={classNames('text-base font-medium text-primary-900', titleStyle)}>
            {title}
          </span>
        </div>
        {!!subTitle && <span className="text-base font-light text-primary-900">{subTitle}</span>}
      </div>
      <Toggle state={!!checked} handleToggle={onPress} />
    </div>
  );
}
